import React from "react";
import ButtonLoading from "../Button/ButtonLoading";
import ModalBasic from "../ModalBasic";
import { ReactComponent as TrashIcon } from "../../assets/icons/trash-01.svg";

export default function ModalDelete({
  title,
  showDeleteConfirmationModal,
  setShowDeleteConfirmationModal,
  DeleteFunction,
  buttonLoading,
}) {
  return (
    <ModalBasic
      id="delete-modal"
      title="Delete"
      icon={<TrashIcon />}
      open={showDeleteConfirmationModal}
      setOpen={setShowDeleteConfirmationModal}
    >
      <div className="flex space-x-4 p-5">
        {/* Icon */}
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-rose-100">
          <svg
            className="h-4 w-4 shrink-0 fill-current text-rose-500"
            viewBox="0 0 16 16"
          >
            <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z" />
          </svg>
        </div>
        {/* Content */}
        <div className="w-full">
          {/* Modal header */}
          <div className="mb-2">
            <div className="text-lg font-semibold text-slate-800">
              Delete this {title}?
            </div>
          </div>
          {/* Modal content */}
          <div className="mb-10 text-sm">
            <div className="space-y-2">
              <p>
                {title} will be removed from your list of {title}.
              </p>
            </div>
          </div>
          {/* Modal footer */}
          <div className="flex flex-wrap justify-end space-x-2">
            <button
              className="btn-sm border-slate-200 text-slate-600 hover:border-slate-300"
              onClick={(e) => {
                e.stopPropagation();
                setShowDeleteConfirmationModal(false);
              }}
            >
              Cancel
            </button>
            <ButtonLoading
              buttonName="Yes, Delete"
              backgroundColor="rose"
              onClickFunction={(e) => {
                e.stopPropagation();
                DeleteFunction();
              }}
              isLoading={buttonLoading}
            />
          </div>
        </div>
      </div>
    </ModalBasic>
  );
}
